import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { IonTextarea } from '@ionic/angular/standalone';
import { DecaEditReasonFormModel } from '../deca-forms.model';

@Component({
  selector: 'lib-deca-edit-reason',
  templateUrl: './deca-edit-reason.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, IonTextarea],
})
export class DecaEditReasonComponent {
  public form = input.required<FormGroup<DecaEditReasonFormModel>>();
}
